import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>California Tax Calculator</h3>
          <p>The most comprehensive tax calculation tool for California residents and businesses.</p>
        </div>
        
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul className="footer-links">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/calculator">Tax Calculator</Link></li>
            <li><Link to="/about">About</Link></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h3>Tax Resources</h3>
          <ul className="footer-links">
            <li><a href="https://www.ftb.ca.gov/" target="_blank" rel="noopener noreferrer">California Franchise Tax Board</a></li>
            <li><a href="https://www.cdtfa.ca.gov/" target="_blank" rel="noopener noreferrer">CA Department of Tax and Fee Administration</a></li>
            <li><a href="https://www.irs.gov/" target="_blank" rel="noopener noreferrer">Internal Revenue Service</a></li>
          </ul>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} California Tax Calculator. All rights reserved.</p>
        <p className="disclaimer">This website provides general information that should not be construed as professional tax advice.</p>
      </div>
    </footer>
  );
}

export default Footer;
